<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M12,0A9.511,9.511,0,0,0,2.5,9.5c0,6.547,6.538,12.488,8.541,14.153a1.5,1.5,0,0,0,1.917,0c2-1.665,8.542-7.608,8.542-14.154A9.511,9.511,0,0,0,12,0Zm0,14.5a5,5,0,1,1,5-5A5,5,0,0,1,12,14.5Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'style-two-pin-marker',
    },
    name: {
      type: String,
      required: false,
      default: 'StyleTwoPinMarker',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>